import React, { useEffect, useState } from 'react';
import ComboSimple from '../../../../../shared/components/Combos/Simple';

export const SelectorReferenciasFacturaExpatriados = (props:any) =>{

  let {data, onChange} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {
      setOptions(getOptions())
    }
  },[data])

  useEffect(()=>{
    if(options && options.length>0){
      onChange && onChange(options[0].value)
    }
  },[options])
  
  const getOptions = () =>{
    return data.map((d:any)=> { return { value: d, inputDisplay: d } })
  }

  return (
    <ComboSimple {...props} options={options} name="selectReferenciasFacturaExpatriados"/>
  )
}